import { isFuture } from 'date-fns';

export const isShortlistLive = job => {
  return job !== null && job?.sealed_at === null && isFuture(job.seal_at);
};

export const isShortlistUnlocked = job => {
  return job !== null && job?.unlocked_at !== null;
};
